import styled from 'styled-components';

export const BoundaryPage = styled.div`
   min-height: 100vh;
   display: grid;
   place-items: center;
   padding: 24px;
   background: ${({ theme }) => theme.colors.surfaceMuted};
`;

export const BoundaryCard = styled.div`
   width: 100%;
   max-width: 480px;
   padding: 28px;

   background: ${({ theme }) => theme.colors.surface};
   border: 1px solid ${({ theme }) => theme.colors.border};
   border-radius: 14px;
   box-shadow: ${({ theme }) => theme.shadows.sm};
`;

export const BoundaryTitle = styled.h1`
   margin: 0 0 10px;
   font-size: 20px;
   color: ${({ theme }) => theme.colors.textPrimary};
`;

export const BoundaryText = styled.p`
   margin: 0 0 10px;
   font-size: 14px;
   line-height: 1.55;
   color: ${({ theme }) => theme.colors.textMuted};
`;

export const BoundaryCode = styled.code`
   display: inline-block;
   padding: 2px 6px;

   font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
   font-size: 12.5px;
   color: ${({ theme }) => theme.colors.textPrimary};

   background: ${({ theme }) => theme.colors.surfaceMuted};
   border: 1px solid ${({ theme }) => theme.colors.borderLight};
   border-radius: 6px;
`;

export const BoundaryActions = styled.div`
   display: flex;
   gap: 10px;
   justify-content: flex-end;
   margin-top: 20px;
`;
